import {getSelectedContracts} from "./contractsFunctions";

export const getFirstUnfilledCustomField = (
  contractsValues,
  contractsList,
  fabricatorData,
  receiptSignature = "",
  contractsContext
) => {
  // need to find first un-filled custom field and change the document page to it
  if (fabricatorData && fabricatorData.receiptSettings && fabricatorData.receiptSettings.signIsRequired
    && contractsContext.showReceiptInContract && contractsContext.receiptPages && !receiptSignature) {
    return { page: contractsContext.receiptPages, fieldIndex: 0 }
  }
  let customFieldInfo = { page: -1, fieldIndex: -1 };
  const selectedContracts = getSelectedContracts(contractsList);
  for (const contract of selectedContracts) {
    let {fields, pagesFrom} = contract;
    if (!contractsValues[contract.id]) {
      contractsValues[contract.id] = {};
    }
    const fieldsNeeded = fields.filter(field => {
      return field.isEditable && field.isRequired && field.coords && field.coords.length && !field.isCheckBox // why checkboxes are not required? old support
    })
    for (let i = 0; i <= contract.pagesCount; i++) {
      if (customFieldInfo.page === -1) {
        fieldsNeeded.forEach(field => {
          if (customFieldInfo.page === -1) {
            const sortedFields = field.coords.sort((a, b) => {
              // return (a.fieldIndexOnPage > b.fieldIndexOnPage) ? 1 : -1 // no we need to sort by top because this is incorrect
              const top1 = a.pageRect.height - a.rectangle.ury;
              const top2 = b.pageRect.height - b.rectangle.ury;
              return top1 > top2 ? 1 : -1
            });
            sortedFields.forEach(coord => {
              if (customFieldInfo.page === -1 && (i === coord.page)
                && (!contractsValues[contract.id][coord.page]
                  || !contractsValues[contract.id][coord.page][coord.fieldIndexOnPage]
                  || !contractsValues[contract.id][coord.page][coord.fieldIndexOnPage].value)) {
                customFieldInfo = { page: pagesFrom + coord.page - 1, fieldIndex: coord.fieldIndexOnPage };
              }
            })
          }
        })
      }
    }
  }
  return customFieldInfo;
}

export const getFieldValue = (pageIndex, fieldIndex, activeContract, contractsValues) => {
  if (contractsValues[activeContract.id]
    && contractsValues[activeContract.id][pageIndex]
    && contractsValues[activeContract.id][pageIndex][fieldIndex]) {
    return contractsValues[activeContract.id][pageIndex][fieldIndex].value
  }
  return ""
};

export const getFieldCoords = (contractFields, selectedFieldIndex) => {
  let fieldsCoords = [];
  contractFields.forEach(field => {
    if (!field.isEditable) {
      return;
    }
    field.coords.forEach((coord) => {
      const { fieldIndexOnPage, isRequired } = coord;
      if (field.isCustom) {
        const isSelected = fieldIndexOnPage === selectedFieldIndex;
        if (!isSelected && isRequired) {
          fieldsCoords.push({ coords: fieldCoords, idx: fieldIndexOnPage });
        }
      }
    })
  })
  return fieldsCoords
}

export const getAlreadyFilledSignatureField = (fieldName, contractsValues, contractsList) => {
  let signatureValue = "";
  const selectedContracts = getSelectedContracts(contractsList);
  const withoutRequiredSignatureName = getFieldNameWithoutRequired(fieldName);
  for (const contract of selectedContracts) {
    let {fields} = contract;
    fields.forEach(field => {
      if (signatureValue || !field.isEditable || !field.isSignature) {
        return;
      }
      field.coords.forEach((coord) => {
        if (signatureValue || !coord.fieldName) {
          return;
        }
        const compareName = getFieldNameWithoutRequired(coord.fieldName);
        if ((compareName !== withoutRequiredSignatureName) || (compareName === "<$signature>")) {
          // only signature1, signature2 should match
          return
        }
        signatureValue = getFieldValue(coord.page, coord.fieldIndexOnPage, contract, contractsValues);
      })
    })
  }
  return signatureValue;
}

export const getFieldNameWithoutRequired = (fieldName = "") => {
  if (!fieldName || typeof fieldName !== "string") {
    return ""
  }
  return fieldName.replace("@", "")
}
